<div class="flex-column gap flex-1 p-2">
    @if (data.item) {
        <div>{{ data.item.offer.code }} {{ data.item.offer.name }}</div>
    }
    <app-date-input
        [formField]="fields.validFrom"
        label="inputs.validFrom"
        [showClear]="hasCredits"
        timeType="startOfDay"
    />

    <app-date-input
        [formField]="fields.validTo"
        label="inputs.validTo"
        [showClear]="hasCredits"
        timeType="endOfDay"
    />

    @if (offers(); as offerOptions) {
        <app-multi-select-input
            [formField]="fields.offerIds"
            [infiniteScroll]="offerOptions"
            valueKey="id"
            labelKey="name"
            filterBy="name"
            [maxSelectedLabels]="3"
            label="service.settings.group.upsertDialog.offers.activities"
        />
    }
    @if (hasCredits) {
        <app-number-input
            [formField]="fields.creditPrice"
            label="socialCredits.groups.fields.creditPrice"
            [maxFractionDigits]="2"
        />
    }
</div>
<div
    #dialogFooter
    class="p-dialog-footer"
>
    <app-action-buttons
        [primaryButtonDisability]="fields().invalid() || store.loadingAny()"
        [primaryButtonLoading]="store.loadingAny()"
        [secondaryButtonDisability]="store.loadingAny()"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    />
</div>
